export default class SubmitBtn {
  static DEFAULT = 'default';
  static LOADING = 'loading';
  static RESPONSE = 'response';
  static RATE_LIMIT = 'rate limit';
}